import { render, staticRenderFns } from "./deepProItem.vue?vue&type=template&id=44d88499&scoped=true&"
import script from "./deepProItem.vue?vue&type=script&lang=js&"
export * from "./deepProItem.vue?vue&type=script&lang=js&"
import style0 from "./deepProItem.vue?vue&type=style&index=0&id=44d88499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d88499",
  null
  
)

export default component.exports